export default "__VITE_ASSET__HPcEGi4C__"